import { ApolloProvider } from "@apollo/client";
import type { ReactNode } from "react";

import { client } from "../lib/apolloClient";

type ApolloClientProviderProps = {
  children: ReactNode;
};

export const ApolloClientProvider = ({ children }: ApolloClientProviderProps) => (
  <ApolloProvider client={client}>{children}</ApolloProvider>
);
